import React, { useState, Fragment } from "react";
import { Modal, FormControl, InputGroup, Form } from "react-bootstrap";

function CreateStackModal(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [name, setName] = useState("");

  const handleShow = () => {
    setName("");
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleCreate = () => {
    const trimmed = name.trim();
    if (trimmed.length === 0) {
      return;
    }
    props.onCreate(trimmed);
    handleClose();
  };

  return <Fragment>
    <button type="button" className="btn btn-success" data-cy="new-stack-btn" onClick={handleShow}>
      New stack
    </button>
    <Modal animation={false} show={isOpen} onHide={handleClose} data-cy="new-stack-modal">
      <Modal.Header closeButton>
        <Modal.Title>Create stack</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => { e.preventDefault(); handleCreate(); }}>
          <InputGroup className="mb-3">
            <InputGroup.Text>Name</InputGroup.Text>
            <FormControl
              data-cy="new-stack-name"
              required
              placeholder="Stack name"
              aria-label="Stack name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </InputGroup>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <input type="button" className="btn btn-success" data-cy="create-stack-btn" onClick={handleCreate} value="Create" />
        <button type="button" className="btn btn-secondary" data-cy="close-new-stack-btn" onClick={handleClose}>Close</button>
      </Modal.Footer>
    </Modal>
  </Fragment>;
}

export { CreateStackModal };
